import { render } from "./PopupMain.vue?vue&type=template&id=0284594b&scoped=true"
import script from "./PopupMain.vue?vue&type=script&lang=js"
export * from "./PopupMain.vue?vue&type=script&lang=js"

import "./PopupMain.vue?vue&type=style&index=0&id=0284594b&scoped=true&lang=css"
import "./PopupMain.vue?vue&type=style&index=1&id=0284594b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0284594b"]])

export default __exports__